"use client";

import React from "react";

type ProgressStepsProps = {
  steps: string[];
  currentStep: number;
};

export default function ProgressSteps({ steps, currentStep }: ProgressStepsProps) {
  const progressPct = (currentStep / steps.length) * 100;

  return (
    <div className="w-full mb-8">
      <div className="h-1 w-full rounded-full bg-white/15 overflow-hidden mb-5">
        <div
          className="h-full bg-green rounded-full transition-all duration-300"
          style={{ width: `${progressPct}%` }}
        />
      </div>
      <div className="flex items-center justify-between">
        {steps.map((label, i) => {
          const stepNum = i + 1;
          const active = stepNum === currentStep;
          const done = stepNum < currentStep;
          return (
            <div key={label} className="flex flex-col items-center gap-2 flex-1">
              <span
                className={`flex items-center justify-center w-8 h-8 rounded-full border text-sm font-mono shrink-0 ${
                  active
                    ? "bg-green border-green text-darkGrey font-bold"
                    : done
                      ? "bg-white/20 border-white/40 text-white"
                      : "border-white/30 text-white/50"
                }`}
              >
                {stepNum}
              </span>
              <span
                className={`hidden sm:block text-xs text-center ${
                  active ? "text-white font-semibold" : "text-white/50"
                }`}
              >
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
